import request from '@/utils/request'

export function addCart(data) { // 添加商品到进货单
  return request({
    url: 'cart/add',
    method: 'post',
    data
  })
}

export function getCartList(params) { // 获取购物车列表
  return request({
    url: 'cart/list',
    method: 'get',
    params
  })
}

export function deleteCartItem(data) { // 删除进货单中的某个商品
  return request({
    url: 'cart',
    method: 'delete',
    data
  })
}

export function deleteSkuItem(params) { // 删除进货单中的某个商品的某个sku
  return request({
    url: `cart/sku/delete/${params}`,
    method: 'delete'
  })
}

export function updateProductAttr(data) { // 修改购物车中商品的规格
  return request({
    url: 'cart/update/attr',
    method: 'post',
    data
  })
}
export function updateSkuNum(params) { // 修改购物车中某个商品的数量
  return request({
    url: 'cart/update/quantity',
    method: 'get',
    params
  })
}


// 设置代发或者自提
export function setPickUp(data) {
  return request({
    url: 'cart/pick_up',
    method: 'post',
    data
  })
}


export function cartConfirmOrder(data) { // 根据购物车信息生成确认单信息
  return request({
    url: 'order/generateConfirmOrder/v2',
    method: 'post',
    data
  })
}

export function cartSubmitOrder(data) { // 根据购物车信息生成订单
  return request({
    url: 'order/generateOrder',
    method: 'post',
    data
  })
}

export function immediatelyConfirmOrder(data) { // 立即订购生成确认单信息
  return request({
    url: 'order/immediately/generateConfirmOrder/v2',
    method: 'post',
    data
  })
}

export function freightNumber(data) { // 运费计算
  return request({
    url: 'order/freightNumber/v2',
    method: 'post',
    data
  })
}



export function freightAllNumber(data) { // 运费计算
  return request({
    url: 'order/freightNumber/v3',
    method: 'post',
    data
  })
}

export function freightAllGenerate(data) { // 购物车运费服务费计算
  return request({
    url: 'order/freightGenerate/v3',
    method: 'post',
    data
  })
}


export function freightGenerate(data) { // 购物车运费计算
  return request({
    url: 'order/freightGenerate/v2',
    method: 'post',
    data
  })
}

export function immediatelySubmitOrder(data) { // 立即订购生成订单
  return request({
    url: 'order/immediately/generateOrder',
    method: 'post',
    data
  })
}

export function generateBehalfOrder(data) { // 代发生成订单
  return request({
    url: 'order/immediately/generateBehalfOrder',
    method: 'post',
    data
  })
}

export function immediatelyPay(data) { // 立即支付
  return request({
    url: 'order/immediately/pay',
    method: 'post',
    data
  })
}

export function payOrder(data) { // 订单支付
  return request({
    url: 'order/pay',
    method: 'post',
    data
  })
}

//没用 暂时保留
export function getRechargeResult(params) { // 查看是否充值成功
  return request({
    url: 'pay/judge',
    method: 'get',
    params
  })
}
//查询订单下单信息
export function selectPlaceOrder(params) {
  return request({
    url: 'order/selectPlaceOrder',
    method: 'get',
    params:params
  })
}

// new
export function orderList(params) { // 订单列表
  return request({
    url: 'order',
    method: 'get',
    params
  })
}
export function goodsReturn(params) { // 弹窗条件列表
  return request({
    url: 'api/z/list/all',
    method: 'get',
    params
  })
}
export function getOrderData(params) { // 订单详情
  return request({
    url: 'order/detail',
    method: 'GET',
    params
  })
}

export function getOrderDataV2(params) { // 订单详情
  return request({
    url: 'order/detailv2',
    method: 'GET',
    params
  })
}

export function orderCancel(data) {
  return request({
    url: '/order/cancel',
    method: 'POST',
    data
  })
}
export function returnMoneyAudit(data) {
  return request({
    url: '/order/returnMoneyAudit',
    method: 'POST',
    data
  })
}

export function returnMoneyCancel(data) {
  return request({
    url: '/order/returnMoneyCancel',
    method: 'POST',
    data
  })
}
//申请退款
export function returnPay(data) {
  return request({
    url: '/order/returnPay',
    method: 'POST',
    data
  })
}
//可退款金额
export function returnPayMoney(data) {
  return request({
    url: '/order/returnPayMoney',
    method: 'POST',
    data
  })
}
//申请退款
export function returnSelfPay(data) {
  return request({
    url: '/order/returnSelfPay',
    method: 'POST',
    data
  })
}
//可退款金额
export function returnSelfPayMoney(data) {
  return request({
    url: '/order/returnSelfPayMoney',
    method: 'POST',
    data
  })
}



export function orderLogistics(params) { // 物流信息
  return request({
    url: '/order/logistics',
    method: 'GET',
    params
  })
}

export function ordersLogistics(params) { // 退货物流信息
  return request({
    url: '/order/slogistics',
    method: 'GET',
    params
  })
}

/**
 * 订单号识别
 * @param data
 * @returns {*}
 */
export function freightSearch(num) {
  return request({
    url: '/order/freight/list',
    method: 'get',
    params: num
  });
}

/**
 * 订单号识别
 * @param data
 * @returns {*}
 */
export function freightCode(num) {
  return request({
    url: '/order/freight/code',
    method: 'get',
    params: num
  });
}

export function delOrder(data) { // 删除订单
  return request({
    url: '/order',
    method: 'DELETE',
    data
  })
}

export function afterSales(params) { // 取消进度
  return request({
    url: '/after/sales/detail',
    method: 'GET',
    params
  })
}

// 再次购买列表
export function orderAgainBuy(params) {
  return request({
    url: '/order/again/buy',
    method: 'GET',
    params
  })
}

export function confirmReceiving(data) {
  return request({
    url: '/order/confirm/Receiving',
    method: 'post',
    data
  })
}

export function commentCreate(data) {
  return request({
    url: 'api/y/comment/create',
    method: 'post',
    data
  })
}

export function queryPayStatus(params) {
  return request({
    url: '/pay/order',
    method: 'get',
    params
  })
}

export function orderRecycle(data) {
  return request({
    url: 'order/recycle',
    method: 'delete',
    data
  })
}

export function cancelOrderData(data) {
  return request({
    url: '/order/cancel/page',
    method: 'post',
    data
  })
}
//地址解析
export function addressResolution(params) {
  return request({
    url: '/order/address/resolution',
    method: 'get',
    params
  })
}

//获取第三方代发信息
export function behalfInfo(params) {
  return request({
    url: '/order/behalfInfo',
    method: 'get',
    params
  })
}
